import { __decorate } from 'tslib';
import { EventEmitter, Input, Output, Component, ChangeDetectionStrategy, NgModule } from '@angular/core';
import { TuiMonth, ALWAYS_FALSE_HANDLER, TUI_FIRST_DAY, TUI_LAST_DAY, nullableSame, tuiDefaultProp, TuiMapperPipeModule } from '@taiga-ui/cdk';
import { TUI_DEFAULT_MARKER_HANDLER } from '@taiga-ui/core/constants';
import { CommonModule } from '@angular/common';
import { TuiPrimitiveCalendarModule } from '@taiga-ui/core/components/primitive-calendar';
import { TuiPrimitiveYearPickerModule } from '@taiga-ui/core/components/primitive-year-picker';
import { TuiScrollbarModule } from '@taiga-ui/core/components/scrollbar';
import { TuiPrimitiveYearMonthPaginationModule } from '@taiga-ui/core/internal/primitive-year-month-pagination';

// @dynamic
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@taiga-ui/core/components/scrollbar';
import * as ɵngcc3 from '@taiga-ui/core/components/primitive-year-picker';
import * as ɵngcc4 from '@taiga-ui/core/internal/primitive-year-month-pagination';
import * as ɵngcc5 from '@taiga-ui/core/components/primitive-calendar';
import * as ɵngcc6 from '@taiga-ui/cdk';

function TuiCalendarComponent_tui_scrollbar_0_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "tui-scrollbar", 2);
    ɵngcc0.ɵɵelementStart(1, "tui-primitive-year-picker", 3);
    ɵngcc0.ɵɵlistener("yearClick", function TuiCalendarComponent_tui_scrollbar_0_Template_tui_primitive_year_picker_yearClick_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.onPickerYearClick($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("min", ctx_r0.min)("max", ctx_r0.max)("initialItem", ctx_r0.year)("value", ctx_r0.value);
} }
function TuiCalendarComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "tui-primitive-year-month-pagination", 4);
    ɵngcc0.ɵɵlistener("valueChange", function TuiCalendarComponent_ng_template_1_Template_tui_primitive_year_month_pagination_valueChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.onPaginationValueChange($event); })("yearClick", function TuiCalendarComponent_ng_template_1_Template_tui_primitive_year_month_pagination_yearClick_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.onPaginationYearClick($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(1, "tui-primitive-calendar", 5);
    ɵngcc0.ɵɵlistener("hoveredItemChange", function TuiCalendarComponent_ng_template_1_Template_tui_primitive_calendar_hoveredItemChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.onHoveredItemChange($event); })("dayClick", function TuiCalendarComponent_ng_template_1_Template_tui_primitive_calendar_dayClick_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.onDayClick($event); });
    ɵngcc0.ɵɵpipe(2, "tuiMapper");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("min", ctx_r2.computedMinViewedMonth)("max", ctx_r2.computedMaxViewedMonth)("value", ctx_r2.month);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("showAdjacent", ctx_r2.showAdjacent)("value", ctx_r2.value)("month", ctx_r2.month)("disabledItemHandler", ɵngcc0.ɵɵpipeBind4(2, 9, ctx_r2.disabledItemHandler, ctx_r2.disabledItemHandlerMapper, ctx_r2.min, ctx_r2.max))("markerHandler", ctx_r2.markerHandler)("hoveredItem", ctx_r2.hoveredItem);
} }
let TuiCalendarComponent = class TuiCalendarComponent {
    constructor() {
        this.month = TuiMonth.currentLocal();
        this.value = null;
        this.disabledItemHandler = ALWAYS_FALSE_HANDLER;
        this.min = TUI_FIRST_DAY;
        this.max = TUI_LAST_DAY;
        this.minViewedMonth = TUI_FIRST_DAY;
        this.maxViewedMonth = TUI_LAST_DAY;
        this.hoveredItem = null;
        this.showAdjacent = true;
        this.markerHandler = TUI_DEFAULT_MARKER_HANDLER;
        this.dayClick = new EventEmitter();
        this.monthChange = new EventEmitter();
        this.hoveredItemChange = new EventEmitter();
        this.year = null;
        this.disabledItemHandlerMapper = (disabledItemHandler, min, max) => item => item.dayBefore(min) || item.dayAfter(max) || disabledItemHandler(item);
    }
    get computedMinViewedMonth() {
        return this.minViewedMonth.monthSameOrAfter(this.min)
            ? this.minViewedMonth
            : this.min;
    }
    get computedMaxViewedMonth() {
        return this.maxViewedMonth.monthSameOrBefore(this.max)
            ? this.maxViewedMonth
            : this.max;
    }
    onPaginationYearClick(year) {
        this.year = year;
    }
    onPickerYearClick({ year }) {
        this.year = null;
        this.updateViewedMonth(new TuiMonth(year, this.month.month));
    }
    onPaginationValueChange(month) {
        this.updateViewedMonth(month);
    }
    onDayClick(day) {
        this.dayClick.emit(day);
    }
    onHoveredItemChange(day) {
        this.updateHoveredDay(day);
    }
    updateViewedMonth(month) {
        if (this.month.monthSame(month)) {
            return;
        }
        this.month = month;
        this.monthChange.emit(month);
    }
    updateHoveredDay(day) {
        if (nullableSame(this.hoveredItem, day, (a, b) => a.daySame(b))) {
            return;
        }
        this.hoveredItem = day;
        this.hoveredItemChange.emit(day);
    }
};
TuiCalendarComponent.ɵfac = function TuiCalendarComponent_Factory(t) { return new (t || TuiCalendarComponent)(); };
TuiCalendarComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TuiCalendarComponent, selectors: [["tui-calendar"]], inputs: { month: "month", value: "value", disabledItemHandler: "disabledItemHandler", min: "min", max: "max", minViewedMonth: "minViewedMonth", maxViewedMonth: "maxViewedMonth", hoveredItem: "hoveredItem", showAdjacent: "showAdjacent", markerHandler: "markerHandler" }, outputs: { dayClick: "dayClick", monthChange: "monthChange", hoveredItemChange: "hoveredItemChange" }, decls: 3, vars: 2, consts: [["automation-id", "tui-calendar__scrollbar", "class", "scrollbar", 4, "ngIf", "ngIfElse"], ["calendar", ""], ["automation-id", "tui-calendar__scrollbar", 1, "scrollbar"], ["automation-id", "tui-calendar__year", 3, "min", "max", "initialItem", "value", "yearClick"], ["automation-id", "tui-calendar__pagination", 1, "pagination", 3, "min", "max", "value", "valueChange", "yearClick"], ["automation-id", "tui-calendar__calendar", 3, "showAdjacent", "value", "month", "disabledItemHandler", "markerHandler", "hoveredItem", "hoveredItemChange", "dayClick"]], template: function TuiCalendarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, TuiCalendarComponent_tui_scrollbar_0_Template, 2, 4, "tui-scrollbar", 0);
        ɵngcc0.ɵɵtemplate(1, TuiCalendarComponent_ng_template_1_Template, 3, 14, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.year)("ngIfElse", _r1);
    } }, directives: [ɵngcc1.NgIf, ɵngcc2.TuiScrollbarComponent, ɵngcc3.TuiPrimitiveYearPickerComponent, ɵngcc4.TuiPrimitiveYearMonthPaginationComponent, ɵngcc5.TuiPrimitiveCalendarComponent], pipes: [ɵngcc6.TuiMapperPipe], styles: ["[_nghost-%COMP%]{display:block;height:18.25rem;width:15.75rem;padding:1rem 1.125rem;box-sizing:content-box}.scrollbar[_ngcontent-%COMP%]{height:18.25rem;width:16.875rem}.pagination[_ngcontent-%COMP%]{margin-bottom:1rem}"], changeDetection: 0 });
__decorate([
    Input(),
    tuiDefaultProp()
], TuiCalendarComponent.prototype, "month", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiCalendarComponent.prototype, "value", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiCalendarComponent.prototype, "disabledItemHandler", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiCalendarComponent.prototype, "min", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiCalendarComponent.prototype, "max", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiCalendarComponent.prototype, "minViewedMonth", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiCalendarComponent.prototype, "maxViewedMonth", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiCalendarComponent.prototype, "hoveredItem", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiCalendarComponent.prototype, "showAdjacent", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiCalendarComponent.prototype, "markerHandler", void 0);
__decorate([
    Output()
], TuiCalendarComponent.prototype, "dayClick", void 0);
__decorate([
    Output()
], TuiCalendarComponent.prototype, "monthChange", void 0);
__decorate([
    Output()
], TuiCalendarComponent.prototype, "hoveredItemChange", void 0);

let TuiCalendarModule = class TuiCalendarModule {
};
TuiCalendarModule.ɵfac = function TuiCalendarModule_Factory(t) { return new (t || TuiCalendarModule)(); };
TuiCalendarModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TuiCalendarModule });
TuiCalendarModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            TuiPrimitiveYearMonthPaginationModule,
            TuiPrimitiveCalendarModule,
            TuiPrimitiveYearPickerModule,
            TuiScrollbarModule,
            TuiMapperPipeModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiCalendarComponent, [{
        type: Component,
        args: [{
                selector: 'tui-calendar',
                template: "<tui-scrollbar\n    *ngIf=\"year; else calendar\"\n    automation-id=\"tui-calendar__scrollbar\"\n    class=\"scrollbar\"\n>\n    <tui-primitive-year-picker\n        automation-id=\"tui-calendar__year\"\n        [min]=\"min\"\n        [max]=\"max\"\n        [initialItem]=\"year\"\n        [value]=\"value\"\n        (yearClick)=\"onPickerYearClick($event)\"\n    ></tui-primitive-year-picker>\n</tui-scrollbar>\n<ng-template #calendar>\n    <tui-primitive-year-month-pagination\n        automation-id=\"tui-calendar__pagination\"\n        class=\"pagination\"\n        [min]=\"computedMinViewedMonth\"\n        [max]=\"computedMaxViewedMonth\"\n        [value]=\"month\"\n        (valueChange)=\"onPaginationValueChange($event)\"\n        (yearClick)=\"onPaginationYearClick($event)\"\n    ></tui-primitive-year-month-pagination>\n    <tui-primitive-calendar\n        automation-id=\"tui-calendar__calendar\"\n        [showAdjacent]=\"showAdjacent\"\n        [value]=\"value\"\n        [month]=\"month\"\n        [disabledItemHandler]=\"disabledItemHandler | tuiMapper: disabledItemHandlerMapper:min:max\"\n        [markerHandler]=\"markerHandler\"\n        [hoveredItem]=\"hoveredItem\"\n        (hoveredItemChange)=\"onHoveredItemChange($event)\"\n        (dayClick)=\"onDayClick($event)\"\n    ></tui-primitive-calendar>\n</ng-template>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [":host{display:block;height:18.25rem;width:15.75rem;padding:1rem 1.125rem;box-sizing:content-box}.scrollbar{height:18.25rem;width:16.875rem}.pagination{margin-bottom:1rem}"]
            }]
    }], function () { return []; }, { month: [{
            type: Input
        }], value: [{
            type: Input
        }], disabledItemHandler: [{
            type: Input
        }], min: [{
            type: Input
        }], max: [{
            type: Input
        }], minViewedMonth: [{
            type: Input
        }], maxViewedMonth: [{
            type: Input
        }], hoveredItem: [{
            type: Input
        }], showAdjacent: [{
            type: Input
        }], markerHandler: [{
            type: Input
        }], dayClick: [{
            type: Output
        }], monthChange: [{
            type: Output
        }], hoveredItemChange: [{
            type: Output
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiCalendarModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    TuiPrimitiveYearMonthPaginationModule,
                    TuiPrimitiveCalendarModule,
                    TuiPrimitiveYearPickerModule,
                    TuiScrollbarModule,
                    TuiMapperPipeModule,
                ],
                declarations: [TuiCalendarComponent],
                exports: [TuiCalendarComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiCalendarModule, { declarations: function () { return [TuiCalendarComponent]; }, imports: function () { return [CommonModule,
        TuiPrimitiveYearMonthPaginationModule,
        TuiPrimitiveCalendarModule,
        TuiPrimitiveYearPickerModule,
        TuiScrollbarModule,
        TuiMapperPipeModule]; }, exports: function () { return [TuiCalendarComponent]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiCalendarComponent, TuiCalendarModule };

